import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { logger } from '@nykaa/logger';
import { screenType } from '@nykaa/auth-shared/store/constants';
import { fetchSignupBanner } from 'shared/store/auth/service';
import { isValidArrayLength } from '@nykaa/utils/validations';
import { State } from 'store/types';
import { getMobileNumberLocal } from 'shared/helpers/auth';
import { FETCH_ACTION_ERROR } from 'shared/components/Error/constant';
import Auth from 'layouts/Auth';
import { trackView, TRACKING } from './helper';
import { pushEvent } from 'helpers/utils/dataLayer';
import { HIDE_SMART_BANNER } from 'shared/constants';

const DN_PAGE_SECTION = '*';
const DN_PAGE_DATA = 'default';

const Component = () => {
  const [bannerWidgets, setWidgets] = useState([]);
  const [widgetsLoaded, setWidgetsLoaded] = useState(false);
  const showScreen = useSelector((state: State) => state.appReducer.showSignUp);

  const signupBannerAdplatformEnabled = useSelector(
    (state: State) => state.remoteConfig.switches.signupBannerAdplatformEnabled
  );
  const number = __SERVER__ ? '' : getMobileNumberLocal();
  useEffect(() => {
    if (showScreen) {
      trackView(number || '');
      pushEvent(TRACKING.SIGNUP_NUDGE_OPENED);
      pushEvent(HIDE_SMART_BANNER);
    }
  }, [number, showScreen]);

  useEffect(() => {
    if (
      signupBannerAdplatformEnabled &&
      !isValidArrayLength(bannerWidgets) &&
      showScreen &&
      !widgetsLoaded
    ) {
      const widgetParams = {
        page_type: screenType.MWEB_SIGNUP_PROMPT,
        page_data: DN_PAGE_DATA,
        page_section: DN_PAGE_SECTION,
        platform: __PLATFORM__,
      };
      fetchSignupBanner(widgetParams)
        .then((data) => {
          setWidgets(data);
        })
        .catch((err) => {
          logger.error(err, FETCH_ACTION_ERROR);
        });
      setWidgetsLoaded(true);
    }
  }, [signupBannerAdplatformEnabled, bannerWidgets, showScreen, widgetsLoaded]);

  return (
    !!showScreen && (
      <Auth
        isNudge
        bannerWidgets={bannerWidgets}
        signupBannerAdplatformEnabled={signupBannerAdplatformEnabled}
      />
    )
  );
};

export default Component;
